//#region src/bite_platform.ts
var BitePlatform = /* @__PURE__ */ function(BitePlatform) {
	BitePlatform["KioskIos"] = "kiosk-ios";
	BitePlatform["KioskAndroid"] = "kiosk-android";
	BitePlatform["KioskIosGarcon"] = "kiosk-ios-garcon";
	BitePlatform["KioskAndroidGarcon"] = "kiosk-android-garcon";
	BitePlatform["KioskSignageOsGarcon"] = "kiosk-signageos-garcon";
	BitePlatform["KioskChromeOsGarcon"] = "kiosk-chromeos-garcon";
	BitePlatform["Flash"] = "flash";
	return BitePlatform;
}(BitePlatform || {});
//#endregion
export { BitePlatform };

//# sourceMappingURL=bite_platform.js.map